import { useWindowSize } from "@/helpers/useWindowSize.ts";

export const useIsMobile = () => {
  const { width = 0 } = useWindowSize();

  return width <= 1024;
};
